import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { API_URLS } from "../App";

const OAuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get("code");
      const state = searchParams.get("state");

      if (!code || !state) {
        console.log("Missing code or state parameter");
        // window.location.href = '/';
        return;
      }

      // Parse state to get tenantId, provider, and optional redirectUrl
      // State format: "tenantId:provider" or "tenantId:provider:redirectUrl"
      let tenantId = state;
      let provider = "google";
      let redirectUrl: string | null = null;

      if (state.includes(":")) {
        const parts = state.split(":");
        tenantId = parts[0];
        provider = parts[1];
        // If there's a third part, it's the redirect URL
        if (parts.length > 2) {
          redirectUrl = parts.slice(2).join(":"); // Join in case URL contains colons
        }
      }

      try {
        // Exchange code for token via backend
        const response = await fetch(
          `${API_URLS.API_BASE_URL}/api/microsite/auth/callback/${provider}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              code,
              tenant_id: tenantId,
              provider: provider.toUpperCase(),
            }),
          },
        );

        if (!response.ok) {
          throw new Error("OAuth callback failed");
        }

        const data = await response.json();

        // Redirect to tenant subdomain with token and optional redirect URL
        const protocol = window.location.protocol;
        const port = window.location.port;
        const host = window.location.hostname;
        let subdomainUrl = `${protocol}//${tenantId}.${host}:${port}/auth/set-token?token=${data.token}`;

        if (redirectUrl) {
          subdomainUrl += `&redirect_url=${encodeURIComponent(redirectUrl)}`;
        }

        window.location.href = subdomainUrl;
      } catch (error) {
        console.log("Authentication error:", error);
        // window.location.href = '/';
      }
    };

    handleCallback();
  }, [searchParams]);

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f9fafb",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            marginBottom: "1rem",
            display: "inline-block",
            height: "3rem",
            width: "3rem",
            border: "4px solid #3b82f6",
            borderTopColor: "transparent",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        ></div>
        <p style={{ fontSize: "1.125rem", color: "#374151" }}>
          A autenticar...
        </p>
      </div>
      <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
    </div>
  );
};

export default OAuthCallback;
